import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { RouteError } from "./components/RouteError";
import { RouteSkeleton } from "./components/RouteSkeleton";
import { LandingPage } from "./pages/LandingPage";

const MunicipalityPage = lazy(() =>
  import("./pages/MunicipalityPage").then((module) => ({ default: module.MunicipalityPage })),
);
const AuthorityPage = lazy(() =>
  import("./pages/AuthorityPage").then((module) => ({ default: module.AuthorityPage })),
);
const AboutPage = lazy(() =>
  import("./pages/AboutPage").then((module) => ({ default: module.AboutPage })),
);
const ComparePage = lazy(() =>
  import("./pages/ComparePage").then((module) => ({ default: module.ComparePage })),
);

export const router = createBrowserRouter([
  {
    element: <AppShell />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <LandingPage /> },
      {
        path: "m/:code",
        element: (
          <Suspense fallback={<RouteSkeleton />}>
            <MunicipalityPage />
          </Suspense>
        ),
      },
      {
        path: "a/:code",
        element: (
          <Suspense fallback={<RouteSkeleton />}>
            <AuthorityPage />
          </Suspense>
        ),
      },
      {
        path: "compare",
        element: (
          <Suspense fallback={<RouteSkeleton />}>
            <ComparePage />
          </Suspense>
        ),
      },
      {
        path: "about",
        element: (
          <Suspense fallback={<RouteSkeleton />}>
            <AboutPage />
          </Suspense>
        ),
      },
    ],
  },
]);
